function IconText({icon, text}) {
    return (
        <div className={`flex flex-gap-medium flex-align-center`}>
            {icon}
            <b>{text}</b>
        </div>
    );
}

export default IconText;